// frontend/src/pages/PublicProfilePage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Image, Spinner, Alert } from 'react-bootstrap';
import {  Instagram, Twitter, GitHub, Linkedin, Globe, 
  Youtube, Facebook, Link as LinkIcon, 
  Image as ImageIcon, Save, Eye,
  Trash2, Plus, ChevronUp, ChevronDown,
  Droplet, AlertCircle , Coffee, Twitch, MessageCircle , Headphones, Heart , X , Info, Send, Check } from 'react-feather';
import { api } from '../utils/Api';
import Icon from '../components/Icon';
import FloatingCTA from '../components/FloatingCTA';  // ← Importar
import NotFoundPage from '../components//NotFoundPage'; // ← Importar

import '../assets/css/PublicProfilePage.css';


const PublicProfilePage = () => {
  const { username } = useParams();
  const [profile, setProfile] = useState(null);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);

  // Iconos disponibles
  const iconMap = {
    instagram: Instagram,
    twitter: Twitter,
    github: GitHub,
    linkedin: Linkedin,
    whatsapp: (props) => <Icon name="whatsapp" {...props} />,
    link: LinkIcon
  };

useEffect(() => {
  const loadPublicProfile = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/profiles/${username}`);
      // console.log('📥 Datos completos:', response.data);  // ← Ver estructura
      
      if (response.data.success) {
        // console.log('👤 Profile data:', response.data.data.profile);  // ← Ver perfil
        // console.log('🔗 Links data:', response.data.data.links);      // ← Ver links
        setProfile(response.data.data.profile);
        setLinks(response.data.data.links);
        setUserData(response.data.data.user)
      } else {
        setError('Perfil no encontrado');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Error al cargar el perfil');
    } finally {
      setLoading(false);
    }
  };
  loadPublicProfile();
}, [username]);

 const handleLinkClick = (linkId, url) => {
  // Registrar click en background (no esperar respuesta)
  api.post(`/links/${linkId}/click`).catch(err => {
    // Ignorar errores, no afecta la navegación
    console.log('Click registrado en background');
  });
  
  // Abrir URL en nueva pestaña INMEDIATAMENTE
  // window.open(url, '_blank', 'noopener,noreferrer');
};

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (error || !profile) {
    return (
      <NotFoundPage 
        title="¡Ups! No encontramos al creador que buscas"
        message={`El perfil "${username}" no existe o no está disponible.`}
        showHomeButton={true}
        showSearchButton={false}
      />
    );
  }

  return (
    <div 
      className="public-profile min-vh-100 d-flex align-items-start justify-content-start"
      style={{ backgroundColor: profile.background_color || '#ffffff' }}
    >
      <Container style={{ maxWidth: '500px' }}>
        {/* Banner */}
        {profile.background_image_url && (
          <div className="banner-container mb-4 ">
            <Image 
              src={profile.background_image_url} 
              fluid 
              className="w-100 rounded"
              style={{ maxHeight: '150px', objectFit: 'cover' }}
            />
          </div>
        )}

        {/* Avatar y nombre */}
        
        <div className="text-center mb-4 position-relative"  style={{  marginTop:  !profile.background_image_url ? '25%' : '-15%' }}>
          <Image 
            src={  profile.icon_url ||
    userData?.avatar ||  // ← Probar con 'avatar'
    userData?.avatar_url ||
    'https://via.placeholder.com/100'} 

            roundedCircle 
            width={100} 
            height={100}
            className="border border-3 mb-3"
            style={{ borderColor: profile.button_color || '#0d6efd' }}
          />
          <h2 style={{ color: profile.title_color }}>
            {profile.display_name || 'Usuario'}
          </h2>
          {profile.bio && (
            <p className="" style={{ color: profile.title_color }}>{profile.bio}</p>
          )}
        </div>

        {/* Links */}
        <div className="links-container">
          {links.map((link) => {
            const IconComponent = iconMap[link.icon] || LinkIcon;
            return (
              <a
                key={link.id}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center justify-content-between p-3 mb-3 rounded text-decoration-none"
                style={{
                  backgroundColor: profile.button_color || '#0d6efd',
                  color: '#ffffff'
                }}
                onClick={() => handleLinkClick(link.id)}
              >
                <span className="d-flex align-items-center">
                  <IconComponent size={20} className="me-2" />
                  {link.title}
                </span>
                  {/* <small className="opacity-75">{link.clicks || 0} clicks</small> */}
              </a>
            );
          })}
        </div>
        
      </Container>
        <FloatingCTA />
    </div>
  );
};

export default PublicProfilePage;